var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showSection
    ? _c(
        "section",
        {
          staticClass: "lpu-promotions d-flex flex-column",
          attrs: { id: "akcii", "data-qa": "lpu_promotions" },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center justify-space-between" },
            [
              _c(
                "h2",
                {
                  staticClass: "text--text ma-0",
                  class: _setup.isMobile ? "text-h6" : "text-h5",
                  attrs: { "data-qa": "lpu_promotions_title" },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_setup.tStatic("Акции")) + "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _setup.hasArchive
                ? _c(
                    "button",
                    {
                      staticClass:
                        "text-body-1 text-decoration-underline primary--text button-reset flex-shrink-0",
                      attrs: {
                        type: "button",
                        "data-qa": "lpu_promotions_archive",
                      },
                      on: {
                        click: function ($event) {
                          _setup.isArchiveOpen = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.tStatic("Архивные")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _setup.isMobile && _setup.promotions.length
            ? _c(_setup.CoreSwiper, {
                attrs: {
                  "slides-per-view": 1,
                  "has-pagination": _setup.promotions.length > 1,
                  "space-between": 8,
                  "placeholder-min-height": _setup.promotionPlaceholderHeight,
                  "auto-height": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(_setup.promotions, function (promotion) {
                          return _c(
                            "div",
                            _vm._b(
                              { key: promotion.id },
                              "div",
                              slideAttrs,
                              false
                            ),
                            [
                              _c(_setup.PromotionCard, {
                                staticClass: "lpu-promotions__item",
                                attrs: { promotion: promotion, lpu: _vm.lpu },
                              }),
                            ],
                            1
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  2228115071
                ),
              })
            : _setup.promotions.length
            ? _c(
                "div",
                { staticClass: "d-flex flex-column" },
                _vm._l(_setup.promotions, function (promotion) {
                  return _c(_setup.PromotionCard, {
                    key: promotion.id,
                    staticClass: "lpu-promotions__item",
                    attrs: { promotion: promotion, lpu: _vm.lpu },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.isArchiveOpen
            ? _c(_setup.PromotionsArchiveDialog, {
                attrs: {
                  value: _setup.isArchiveOpen,
                  "archive-url": _setup.archiveUrl,
                },
                on: {
                  input: function ($event) {
                    _setup.isArchiveOpen = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }